import type { MaybeRefOrGetter } from "vue"
import type { ServerResponse } from "@/http"
import type { Location, TimezoneResponse } from "@/models"
import { useQuery } from "@tanstack/vue-query"
import { computed, toValue } from "vue"
import { axios } from "@/axios"
import { Timezone } from "@/models"

/**
 * Retrieves timezone information for a given latitude and longitude
 */
export async function getTimezoneFromLocation(latitude?: number, longitude?: number) {
  if (!latitude || !longitude)
    throw new Error("Latitude and longitude are required when attempting to get timezone from location.")

  const endpoint = `api/system/timezone?latitude=${latitude}&longitude=${longitude}`

  const response = await axios.get<ServerResponse<TimezoneResponse>>(endpoint)

  return Timezone.fromResponse(response.data?.Data)
}

export function useGetTimezoneFromLocation(location?: MaybeRefOrGetter<Location | null | undefined>) {
  const locationKey = computed(() => {
    const loc = toValue(location)
    return loc ? { latitude: loc.latitude, longitude: loc.longitude } : null
  })

  return useQuery({
    queryKey: ["getTimezoneFromLocation", locationKey],
    queryFn: () => {
      const loc = toValue(location)
      return getTimezoneFromLocation(loc?.latitude, loc?.longitude)
    },
  })
}
